<h3>Update Profile</h3>
<p>Your profile is not complete. Please fill in the below details.</p>
<form novalidate [formGroup]="profileForm">
  <app-input-field label="First Name" [control]="profileForm.get('firstName')"></app-input-field>
  <app-input-field label="Last Name" [control]="profileForm.get('lastName')"></app-input-field>
  <app-input-field label="Email" [control]="profileForm.get('email')"></app-input-field>
  <app-input-field label="Mobile" [control]="profileForm.get('phone')"></app-input-field>
  <div class="mb-1 mt-1">
    <button mat-raised-button type="submit" color="primary" (click)="onSubmit()">Submit</button>
    <button mat-button (click)="onNoClick()" color="primary" cdkFocusInitial class="ml-2">Cancel</button>
  </div>
</form>
